import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
// import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Result from './Result';
import GraphViews from "./GraphViews";
import GraphView from "./GraphView";
import GraphExplorer from "./GraphExplorer";
import './App.css';
import './styles.css';

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/about" element={<About />} /> */}
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/result/:jobId" element={<Result />} />
        <Route path="/result" element={<Result />} />
        <Route path="/graphs" element={<GraphViews />} />
        <Route path="/graph" element={<GraphView />} />
        <Route path="/graph-explorer" element={<GraphExplorer />} />

      </Routes>

      <Footer />
    </Router>
    
  );
}

export default App;
